export default __webpack_public_path__ + "static/media/csharp.ed6f3588.svg";